import { deleteTestCase } from "./methods";

export const strings = {
  welcomeBack: "Welcome back",
  welcomeDetail: "Welcome back! Please enter your details.",
  searchBar: "Search",
  headerImgAlt: "User Image",
  BlogPageTitle: "All Blogs",
  AddBlogsBtn: "Add a new Blog",
  AddWikiBtn: "Add a new Wikipedia",
  blogEditBtn: "Edit",
  DeleteBtn: "Delete",
  EditBlogTitle: "Edit Post: ",
  addBlogTitle: "Add A Post: ",
  inputTitle: "Title",
  titlePlaceholder: "Title here",
  inputCategory: "Category",
  categoryPlaceholder: "Category here",
  inputDesc: "Description",
  descriptionPlaceholder: "Description here",
  inputBlogger: "Blogger",
  submitButton: "Upload",
  uploadDesc1: "Click to Upload, ",
  uploadDesc2: " or Drag and Drop",
  uploadDesc3: "SVG, PNG, JPG or GIF (max. 800x400px)",
  deleteTitle: "Delete Blog Post",
  deleteDesc:
    "Are you sure you want to delete this blog post? This action cannot be undone!",
  deleteJobTitle: "Delete Job Post",
  deleteJobDesc:
    "Are you sure you want to delete this Job post? This action cannot be undone!",
  deleteEmployeeTitle: "Delete Employee",
  deleteEmployeeDesc:
    "Are you sure you want to delete this Employee? This action cannot be undone!",
  cancelBtn: "Cancel",
  blogImage: "Blog Image",
  bloggerImage: "Blogger Image",
  JobPageTitle: "All Jobs",
  PostJobsBtn: "Post a new Job",
  viewApplicantsBtn: "View Applicants",
  industryCategory: "Industry",
  roleCategory: "Role",
  jobTypeCategory: "Job Type",
  officeCategory: "Offices",
  expLevelCategory: "Experience Level",
  applicantsTitle: "Applicants",
  downloadBtn: "Download",
  detailBtn: "View Detail",
  coverLetter: "Cover Letter",
  employeeTitle: "Employees",
  addEmployeeBtn: "Add new Employee",
  addEmployeeTitle: "Add New Employee: ",
  editEmployeeBtn: "Edit Employee: ",
  employeeName: "Name",
  placeholderName: "Name Here",
  employeeEmail: "Email",
  placeholderEmail: "Email Here",
  employeePhone: "Phone No.",
  placeholderPhone: "Phone Number Here",
  employeeEmgPhone: "Emergency Phone No.",
  employeeRegDate: "Resignation Date",
  placeholderEmgPhone: "Emergency Phone Number Here",
  employeeCnic: "CNIC No.",
  placeholderCnic: "CNIC No. Here",
  employeeDesignation: "Designation",
  joiningDate: "Joining Date",
  placeholderJoiningDate: "Select Date",
  recentDegree: "Add Recent Degree (Optional)",
  employeeImage: "Add Personal Image",
  leavePageTitle: "Approve Leaves",
  approveBtn: "Approve",
  rejectBtn: "Reject",
  rejectTitle: "Reject Leave",
  rejectLeaveDesc:
    "Are you sure you want to Reject? This action cannot be undone.",
  approveTitle: "Approve Leave",
  approveLeaveDesc:
    "Are you sure you want to Approve? This action cannot be undone.",
  detailsTitle: "Description",
  detailsDescription:
    "Here are the attachements regarding Leaves Approvals to validate Employee's Emergency.",
  medicalCertificate: "Medical Certificate:",
  empLeaveTitle: "My Leaves",
  applyLeaveBtn: "Apply for Leave",
  appliedLeaveBtn: "Applied Leaves",
  remainingLeavesBtn: "Remaining Leaves",
  LeaveFormTitle: "Apply for a Leave",
  leaveType: "Leave Type",
  startDate: "Start Date",
  startDatePlaceholder: "Select Date",
  endDate: "End Date",
  endDatePlaceholder: "Select Date",
  details: "Details",
  detailPlaceholder: "Details Here",
  addDocment: "Add doc (Optional)",
  leaveAvailable: "Available Leaves",
  userProfile: "Personal Information",
  saveBtn: "Save Changes",
  hrWikipedia: "HR Wikipedia",
  blogVersion: "Version",
  versionPlaceholder: "Enter Version",
  authorName: "Author Name",
  createdBy: "Created By",
  lastUpdated: "Last Updated",
  editArticle: "Edit Article",
  lineManager: "Line Manager",
  selectEmployee: "Select Employee",
  addData: "Add More Details",
  progress: "Progress",
  goals: "Goal",
  goalPlaceholder: "Goal Here",
  addGoalTitle: "Add New Goal",
  editGoalTitle: "Edit Goal: ",
  name: "EmployeeName",
  deleteGoal: "Delete Goal",
  deleteGoalDesc:
    "Are you sure you want to delete this Goal? This action cannot be undone!",
  contacted: "Contacted Users:",
  resetPassword: "Reset Password",
  AddTestCaseBtn: "Add New Case Study",
  editTestCaseBtn: "Edit Case Studies",
  TestCasesPageTitle: "All Case Studies",
  inputTester: "Case Study Writer",
  deleteTestCase: "Delete Case Study",
  deleteTestCaseDesc:
    "Are you sure you want to delete this case study? This action cannot be undone!",

};
